export const RETAIL = "retail";
export const STANDARD = "standard";
export const NOW = "now";
export const TRADESHOW = "tradeshow";
export const ESSENTIAL = "essential";
export const PROFESSIONAL = "professional";
export const ENTERPRISE = "enterprise";

export type IBrandSubscription =
    | "retail"
    | "standard"
    | "tradeshow"
    | "now"
    | "essential"
    | "professional"
    | "enterprise";

// TODO: update permission values (order) during the implementation of access rules
const ORDER_LIST: { [key in IBrandSubscription]: number } = {
    [RETAIL]: 0,
    [STANDARD]: 1,
    [TRADESHOW]: 2,
    [NOW]: 3,
    [ESSENTIAL]: 4,
    [PROFESSIONAL]: 5,
    [ENTERPRISE]: 6,
};
/**
 * Compare subscriptions to check that the first is wider than the second one.
 * Used for checking access to functionalities that depend on a subscription.
 * @param {IBrandSubscription} a - the subscription to compare.
 * @param {IBrandSubscription} b - the other subscription to compare.
 * @return {boolean} returns true if a includes b.
 */
export const greatOrEqual = (a: IBrandSubscription, b: IBrandSubscription): boolean => ORDER_LIST[a] >= ORDER_LIST[b];
